/**
 * Un almacén simple para compartir parámetros de posición entre componentes.
 */

let shareParams = {
  sr: null,       // Parámetro de rotación (yaw,pitch)
  ss: null,       // Número de sweep
  sid: null       // ID único del sweep (Sweep ID)
};

/**
 * Actualiza el valor del parámetro sr (rotación)
 * @param {string} sr - El valor del parámetro sr (formato "yaw,pitch")
 */
export const setShareParams = (sr) => {
  shareParams.sr = sr;
};

/**
 * Actualiza el número de sweep
 * @param {number} sweepNumber - El número de sweep
 */
export const setSweepNumber = (sweepNumber) => {
  shareParams.ss = sweepNumber;
};

/**
 * Actualiza el ID del sweep
 * @param {string} sweepId - El ID único del sweep
 */
export const setSweepId = (sweepId) => {
  shareParams.sid = sweepId;
};

/**
 * Actualiza todos los parámetros de posición a la vez
 * @param {Object} params - Objeto con los parámetros a actualizar
 * @param {string} [params.sr] - Parámetro de rotación (yaw,pitch)
 * @param {number} [params.ss] - Número de sweep
 * @param {string} [params.sid] - ID único del sweep
 */
export const setAllShareParams = (params) => {
  if (params.sr !== undefined) shareParams.sr = params.sr;
  if (params.ss !== undefined) shareParams.ss = params.ss;
  if (params.sid !== undefined) shareParams.sid = params.sid;
};

/**
 * Obtiene los parámetros para compartir
 * @returns {Object} Los parámetros de compartición
 */
export const getShareParams = () => {
  return { ...shareParams };
};

/**
 * Obtiene el número de sweep actual
 * @returns {number|null} El número de sweep o null si no está definido
 */
export const getSweepNumber = () => {
  return shareParams.ss;
};

/**
 * Obtiene el ID del sweep actual
 * @returns {string|null} El ID del sweep o null si no está definido
 */
export const getSweepId = () => {
  return shareParams.sid;
};